window.onload = function () {
    if($('.map').length > 0) {
        $('.map').each(function () {
            let self = $(this);
            // Define the map
            map = new google.maps.Map(this, {
                center: {lat: 45.502069, lng: -73.553937},
                clickableIcons: true,
                disableDefaultUI: true,
                disableDoubleClickZoom: false,
                fullscreenControl: false,
                mapTypeControl: false,
                mapTypeId: google.maps.MapTypeId.ROADMAP,
                rotateControl: false,
                streetViewControl: false,
                zoom: 15,
                zoomControl: true,
            });

            // Define the geocoder
            geocoder = new google.maps.Geocoder;

            // Define the marker
            marker = new google.maps.Marker({map: map});

            // Define the info window
            infowindow = new google.maps.InfoWindow();

            // Add a click listener to the map
            map.addListener('click', function (e) {

                // Check if there is a place ID
                if (e.placeId) {

                    // Prevent the default info window from showing.
                    e.stop();

                    // Fetch the place details
                    new google.maps.places.PlacesService(map).getDetails({placeId: e.placeId}, function (place, status) {
                        if (status === 'OK') {
                            updateLocationData(place, false);
                        }
                    });

                }
            });

            // Attach the info window to the marker's click listener
            marker.addListener('click', function () {
                infowindow.open(map, marker);
            });

            let uuid = self.data('uuid');

            // Check for pre-existing LAT/LNG coordinates
            if ($(`#mapdata-${uuid}`).val()) {
                // Decode the map data
                var place = JSON.parse($(`#mapdata-${uuid}`).val());

                // Set the marker position
                marker.setPosition({
                    lat: parseFloat(place.geometry.location.lat),
                    lng: parseFloat(place.geometry.location.lng),
                });

                // Center the map on the marker
                if (place.geometry.viewport) {
                    map.fitBounds(place.geometry.viewport);
                } else {
                    map.setCenter(place.getPosition());
                }

                // Update the info window
                infowindow.setContent('<div>' + place.formatted_address + '</div>');
                infowindow.open(map, marker);

                // Check if the browser supports geolocation
            } else if (navigator.geolocation) {

                // Center the map around the user's detected coordinates
                navigator.geolocation.getCurrentPosition(function (position) {
                    map.setCenter({
                        lat: position.coords.latitude,
                        lng: position.coords.longitude,
                    });
                }, function () {
                }, {
                    enableHighAccuracy: true,
                    timeout: 0,
                    maximumAge: 0
                });
            }
        });
    }
};
